import React from "react";

import { WizardOptionWithBlurb } from "@components/Aviation/WizardOptionWithBlurb";
import {
  PRIMARY_ACTIVITY_FAMILY_BLURBS,
  type PrimaryActivityFamily,
} from "@utils/aviationWizardConfig";

type Props = {
  family: PrimaryActivityFamily;
  label: string;
  /** MUI sx for the main title line */
  labelSx?: Record<string, unknown>;
};

/**
 * Activity-family row (screen 1): title + short blurb; hover for detail.
 */
export function ActivityFamilyLabelWithInfo({ family, label, labelSx }: Props) {
  const { summary, detail } = PRIMARY_ACTIVITY_FAMILY_BLURBS[family];
  return (
    <WizardOptionWithBlurb title={label} summary={summary} detail={detail} titleSx={labelSx} />
  );
}
